export const ClientTypes = {
    RARE: 'Clienti rari',
    OCCASIONAL: 'Clienti ocazionali',
    LOYAL: 'Clienti fideli',
    FAN: 'Clienti inraiti',
};

export const ClientTypesTranslationKeys = {
    [ClientTypes.RARE]: 'reports.clientTypes.rare-clients',
    [ClientTypes.OCCASIONAL]: 'reports.clientTypes.occasional-clients',
    [ClientTypes.LOYAL]: 'reports.clientTypes.loyal-clients',
    [ClientTypes.FAN]: 'reports.clientTypes.fan-clients',
};

export const ClientTypesDescriptionTranslationKeys = {
    [ClientTypes.RARE]: 'reports.clientTypes.rare-clients.description',
    [ClientTypes.OCCASIONAL]: 'reports.clientTypes.occasional-clients.description',
    [ClientTypes.LOYAL]: 'reports.clientTypes.loyal-clients.description',
    [ClientTypes.FAN]: 'reports.clientTypes.fan-clients.description',
};
